import ImpersonationBanner from '@apps/myzone-be-eneco/components/ImpersonationBanner';
import AccountLinkDialogProvider from '@apps/myzone-be-eneco/providers/AccountLinkDialogProvider';
import { useSession } from '@eneco/auth';
import { NotificationContextProvider } from '@eneco/components-next/Notification/Notification';
import { SitecoreRouteContainer } from '@eneco/containers';
import DigitalCoreBeProvider from '@eneco/dc-be/provider';
import Layout from '@eneco/layouts/main';
import { AccountsProvider } from '@eneco/next-be/accountsProvider';
import type { NextCatchAllRoute } from '@eneco/next-be/server';
import { getSSP } from '@eneco/next-be/server/getServerSideProps';
import { Box } from '@eneco/sparky';
import { QueryParamProvider } from 'use-query-params';

import NextAdapterPages from '../adapters/NextAdapterPages';
import { businessUnit, countryCode, label, name, transformFunctions } from '../config';
import { useRecommendedAdvanceAmountCaching } from '../hooks/useRecommendedAdvanceAmountCaching';
import components from '../sitecoreComponents';

const CatchAllRoute: NextCatchAllRoute = ({
  accounts,
  dataLayerEvents,
  enableGrayBackground,
  i18n,
  idToken,
  layoutData,
  nbaData,
  path,
  platformHint,
  selectedAccount,
  user,
  impersonation,
}) => {
  const { data } = useSession();
  useRecommendedAdvanceAmountCaching({ crmAccountNumber: selectedAccount?.crmAccountNumber || '' });
  return (
    <SitecoreRouteContainer
      businessUnit={businessUnit}
      components={components}
      dataLayerEvents={dataLayerEvents}
      i18n={i18n}
      idToken={idToken}
      label={label}
      layoutData={layoutData}
      name={name}
      nbaData={nbaData}
      path={path}
      platformHint={platformHint}
      user={user}>
      <DigitalCoreBeProvider
        token={data?.accessToken}
        impersonationSubjectHeader={impersonation?.actsAsIdentityProviderId}>
        <AccountsProvider accounts={accounts} selectedAccount={selectedAccount} impersonation={impersonation}>
          <QueryParamProvider adapter={NextAdapterPages}>
            <ImpersonationBanner>
              <NotificationContextProvider>
                <AccountLinkDialogProvider>
                  <Box backgroundColor={enableGrayBackground ? 'backgroundSecondary' : undefined}>
                    <Layout />
                  </Box>
                </AccountLinkDialogProvider>
              </NotificationContextProvider>
            </ImpersonationBanner>
          </QueryParamProvider>
        </AccountsProvider>
      </DigitalCoreBeProvider>
    </SitecoreRouteContainer>
  );
};

export default CatchAllRoute;

export const getServerSideProps = getSSP({ businessUnit, countryCode, label, transformFunctions });
